export default {
  showDocumentModal: true,
  showHowItWorksModal: false,
  bookACallModalSeen: false
}
